export default "__VITE_ASSET__BvE4Afsa__"